import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from '@contexts/ThemeContext'
import { AuthProvider } from '@contexts/AuthContext'
import AppRoutes from './routes'
import { ToastProvider } from '@contexts/ToastContext'
import { FilterProvider } from '@contexts/FilterContext'
import { createTheme, ThemeProvider as MuiThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import ForcePasswordChangeWrapper from '@components/auth/ForcePasswordChangeWrapper'

// Get base path from environment variable (set during build)
const basePath = import.meta.env.VITE_BASE_PATH || '/'

function App() {
  const muiTheme = createTheme({
    palette: {
      primary: { main: '#6107F3' },
      secondary: { main: '#6F7B83' },
    },
  })
  return (
    <BrowserRouter basename={basePath}>
      <MuiThemeProvider theme={muiTheme}>
        <CssBaseline />
        <ThemeProvider>
          <AuthProvider>
            <ToastProvider>
              <FilterProvider>
                <ForcePasswordChangeWrapper>
                  <AppRoutes />
                </ForcePasswordChangeWrapper>
              </FilterProvider>
            </ToastProvider>
          </AuthProvider>
        </ThemeProvider>
      </MuiThemeProvider>
    </BrowserRouter>
  )
}

export default App
